module.exports = __webpack_public_path__ + "img/icon_sec2_06.0508a92f.png";